import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { storageConfig } from '../../config/storage.config';
import { Application } from '../../models/applications/application.model';
import { ApiApplicationsService } from './api/api-applications.service';
import { AuthenticationService } from '../admin/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {

  public applicationIdSelectedSubject = new Subject<void>();
  public applicationsLoadedSubject = new Subject<void>();

  public applicationIdSelected: number = 0;
  public applications: Application[] = [];

  private applicationIdStored: number | null = null;

  constructor(
    private apiApplicationsService: ApiApplicationsService,
    private authenticationService: AuthenticationService
  ) {
    const applicationIdSelectedStored = localStorage.getItem(storageConfig.applicationIdSelected);
    const applicationIdSelected = Number(applicationIdSelectedStored);
    const isApplicationIdValid = applicationIdSelectedStored !== null && !isNaN(applicationIdSelected);
    this.applicationIdStored = isApplicationIdValid ? applicationIdSelected : null;

    if (this.authenticationService.isUserLogged()) {
      this.loadApplications();
    } else {
      this.authenticationService.currentAdminUserLoggedSubject.subscribe(() => {
        if (this.authenticationService.isUserLogged()) {
          this.loadApplications();
        }
      });
    }
  }

  changeApplication(applicationId: number): void {
    this.applicationIdSelected = applicationId;
    localStorage.setItem(storageConfig.applicationIdSelected, applicationId.toString());
    this.applicationIdSelectedSubject.next();
  }

  private loadApplications(): void {
    this.apiApplicationsService.getApplications().then(
      response => {
        this.applications = response.results;
        const applicationIdToSelect = this.applicationIdStored ?? this.applications[0]?.id ?? 0;
        if (applicationIdToSelect !== 0) {
          this.changeApplication(applicationIdToSelect);
        }
        
        this.applicationsLoadedSubject.next();
      },
      error => { console.error('Failed to load applications', error); }
    );
  }
}
